import jwt_decode from 'jwt-decode';

export const getRoles = () => {
    const jwt = localStorage.getItem('swatim_token');
    if (!jwt) {
        return [];
    }

    const decoded:any = jwt_decode(jwt);
    const userRoles = decoded?.roles.filter(role=> role.startsWith('ROLE_ADMIN'));

    return userRoles;
}

export const getUsername = () => {
    const jwt = localStorage.getItem('swatim_token');
    if (!jwt) {
        return '';
    }

    const decoded:any = jwt_decode(jwt);
    return decoded?.username;
}